import { getBreakpoint } from '../utils/breakpointUtils.js';
import { windowSizeListener } from './windowSizeListener.js';

const listeners = [];
let oldBreakpoint;

const sizeListener = ({ width }) => {
  const newBreakpoint = getBreakpoint(width);
  if (newBreakpoint !== oldBreakpoint) {
    listeners.forEach(listener => listener(newBreakpoint, oldBreakpoint));
    oldBreakpoint = newBreakpoint;
  }
};

export const breakpointChangeListener = listener => {
  windowSizeListener(sizeListener);
  listeners.push(listener);
};
